module.exports = __webpack_public_path__ + "static/media/African-Woman-Business-Woman-Young-Woman-Black-Woman-3439224.e6bfb17c.jpg";